// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2xZ2d","author":"Table_author__1da_S","authorImage":"Table_authorImage__3_2Lg","unreadRow":"Table_unreadRow__2g4Kt"};